import React from 'react';
import { AlertTriangle, Lightbulb, Info } from 'lucide-react';
import { Insight } from '../types';

interface InsightCardProps {
  insight: Insight;
}

const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  // Define icon and style based on insight type
  const getTypeDetails = () => {
    switch (insight.type) {
      case 'alert':
        return {
          icon: <AlertTriangle size={20} />,
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          textColor: 'text-red-700',
          iconColor: 'text-red-500'
        };
      case 'opportunity':
        return {
          icon: <Lightbulb size={20} />,
          bgColor: 'bg-[#f9fff5]',
          borderColor: 'border-[#d0f0c0]',
          textColor: 'text-[#103541]',
          iconColor: 'text-[#7AEA53]'
        };
      case 'info':
      default:
        return {
          icon: <Info size={20} />,
          bgColor: 'bg-blue-50',
          borderColor: 'border-blue-200',
          textColor: 'text-blue-700',
          iconColor: 'text-blue-500'
        };
    }
  };

  const { icon, bgColor, borderColor, textColor, iconColor } = getTypeDetails();

  return (
    <div className={`${bgColor} ${borderColor} border rounded-xl p-5 transition-all hover:shadow-md`}>
      <div className="flex gap-4">
        <div className={`${iconColor} mt-1 flex-shrink-0`}>
          {icon}
        </div>
        <div>
          <h4 className={`font-semibold ${textColor} mb-1`}>{insight.title}</h4>
          <p className="text-[#2E6173] text-sm mb-2">{insight.message}</p>
          <div className="text-sm font-medium bg-white bg-opacity-50 px-3 py-1 rounded-lg inline-block">
            {insight.impact}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightCard;